import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGerarFatura } from "../../../hooks/queries/pagamento/useGerarFatura/useGerarFatura";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { FormaPagamentoEnum } from "../../../enums/formaPagamento";
import { Tracking } from "../../../services/Tracking";

export const usePaymentV2 = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator();
  const [formaPagamento, setFormaPagamento] = useState<FormaPagamentoEnum>();
  const { mutate: gerarFatura, isPending } = useGerarFatura();

  function handleSelecionar(forma: FormaPagamentoEnum) {
    setFormaPagamento(forma);
    Tracking.userAction(
      `mapa:agendamento/pagamento:clique-selecionar-${forma.toLowerCase()}`,
    );
  }

  function handlePagarAgora() {
    if (!uuidAgendamento || !formaPagamento) return;

    Tracking.userAction("mapa:agendamento/pagamento:clique-pagar-agora");

    gerarFatura(
      { uuidAgendamento, formaPagamento },
      {
        onSuccess: () => {
          navigate(
            `/agendamento/${uuidAgendamento}/pagamento/${formaPagamento.toLowerCase()}`,
          );
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error("mapa:agendamento/pagamento:gerar-fatura-falhou", {
            mensagem,
          });
        },
      },
    );
  }

  return {
    stepIndicator,
    formaPagamento,
    handleSelecionar,
    handlePagarAgora,
    podeConfirmar: !!formaPagamento,
    isPending,
  };
};
